import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import {auth} from '../firebase'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/', name: 'web.home',
    component: Home,
    meta: { public: true }
  },
  {
    path: '/login', name: 'account.login',
    component: () => import( /* webpackChunkName: "account" */ '../views/Login.vue'),
    meta: { public: true }
  },
  {
    path: '/register', name: 'account.register',
    component: () => import( /* webpackChunkName: "account" */ '../views/Register.vue'),
    meta: { public: true }
  },
  {
    path: '/passwordreset', name: 'account.passwordreset',
    component: () => import( /* webpackChunkName: "account" */ '../views/PasswordReset.vue'),
    meta: { public: true }
  },
  {
    path: '/about', name: 'website.about',
    component: About,
    meta: { public: true }
  },
  {
    path: '/units', name: 'unit.listing',
    component: () => import(/* webpackChunkName: "unit" */ '../views/units/UnitListing.vue'),
  },
  {
    path: '/units/new', name: 'unit.new',
    component: () => import(/* webpackChunkName: "unit" */ '../views/units/UnitNew.vue')
  },
  {
    path: '/units/:unit_id/edit', name: 'unit.edit', props: (route) => ({ unit_id: route.params.unit_id, start_field: route.query.start_field }),
    component: () => import(/* webpackChunkName: "unit" */ '../views/units/UnitEdit.vue')
  },
  {
    path: '/forces', name: 'force.listing',
    component: () => import(/* webpackChunkName: "force" */ '../views/forces/ForceListing.vue')
  },
  {
    path: '/forces/new', name: 'force.new',
    component: () => import(/* webpackChunkName: "force" */ '../views/forces/ForceNew.vue')
  },
  {
    path: '/forces/:force_id/edit', name: 'force.edit', props: (route) => ({ force_id: route.params.force_id }),
    component: () => import(/* webpackChunkName: "force" */ '../views/forces/ForceEdit.vue')
  },
  {
    path: '/forces/:force_id/units', name: 'force.units', props: (route) => ({ force_id: route.params.force_id }),
    component: () => import(/* webpackChunkName: "force" */ '../views/forces/SelectUnits.vue')
  },
  {
    path: '/forces/:force_id/battle/:battle_id/:step?', name: 'battle.workflow', 
    props: (route) => ({ force_id: route.params.force_id, battle_id: route.params.battle_id, initial_step: route.params.step}),
    component: () => import(/* webpackChunkName: "battle" */ '../views/battles/Workflow.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => !x.meta.public)

  if (requiresAuth && !auth.currentUser) {
    next('/login')
  } else {
    next()
  }
})

export default router
